import {Field, connect} from 'formik'
import {FormRadio} from './'

export const PaymentMethodSelection = connect(({formik}) => {
  const isRecurring = formik.values.interval !== 'single'
  
  // allow reproducing a display bug with ?force-bug=1 for test eng. interviews
  // TODO: delete this and corresponding CSS class later
  const bugged = (new URLSearchParams(window.location.search)).get('force-bug') == 1

  return <div className='donation-form-payment-method-links mb-3'>
    <h4>{I18n.t('donate.payment_method.headline')}</h4>
    <div className="payment-method-radios form-group radio-buttons">
      {
        formik.values._payment_methods.map(name => <Field
          key={name}
          name='payment_method'
          component={FormRadio}
          value={name}
          label={I18n.t(`donate.payment_method.labels.${name}`)}
          className={`payment-method-radio cursor-pointer ${bugged ? 'is-bugged' : ''}`}
          disabled={isRecurring && !formik.values._recurring_payment_methods.includes(name)}
        />)
      }
    </div>
    {formik.values.payment_method == 'direct_deposit' && <DirectDepositInfo />}
    <FiscalYearChangeNotice paymentMethod={formik.values.payment_method} />
  </div>
})

const FiscalYearChangeNotice = ({paymentMethod}) => {
  const urlParams = new URLSearchParams(window.location.search)
  // Use <DonationFormUrl>?fake-date=2021-12-31 for testing
  const now = urlParams.has('fake-date') ? new Date(urlParams.get('fake-date')) : new Date()
  const isNearFiscalYearChange = now.getMonth() == 11 && now.getDate() > 26
  const needsFiscalYearChangeNotice = isNearFiscalYearChange && ['stripe_sepa_debit', 'direct_deposit'].includes(paymentMethod)

  return needsFiscalYearChangeNotice
    ? <div className='bg-green-100 p-3 mb-3'>
      {I18n.t('donate.fiscal_year_change_notice', {old_year: now.getFullYear(), new_year: now.getFullYear() + 1})}
    </div>
    : null
}

const DirectDepositInfo = () => {
  return <div className="-mt-2 mb-3 desktop:-mt-3 bg-yellow-100 p-3">
    <p className="m-0" dangerouslySetInnerHTML={{ __html: I18n.t('donate.direct_deposit_info') }} />
  </div>
}
